<template>
	<div class="stock-info-box-right">
		<div class="card-item" v-for="(item, index) in displayData" :key="index">
			<p>{{ item.value }}{{ item.unit }}</p>
			<p>{{ item.label }}</p>
		</div>
	</div>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import { useStockVO } from '@rebuild/hooks/useStockVO';
import { EN } from '@/locales';
import { convertNumberToCNUnit } from '@/utils/api';

const { isHKStock, isUSStock } = useStockVO();
const { proxy } = getCurrentInstance();

// Props
const props = defineProps({
	stockQuoteData: {
		type: Object,
		default: () => ({})
	}
});

const displayData = computed(() => {
	const rowArray = [
		{
			label: proxy.$t(`enterprise.high`),
			prop: 'highPrice'
		},
		{
			label: proxy.$t(`enterprise.low`),
			prop: 'lowPrice'
		},
		{
			label: proxy.$t(`enterprise.turnover`),
			prop: 'turnoverValue'
		},
		{
			label: proxy.$t(`enterprise.volume`),
			prop: isHKStock.value || isUSStock.value ? 'turnoverVolumeShares' : 'turnoverVolume'
		}
	];

	const formatValueFn = (propName, value) => {
		if (propName == 'changePct') {
			return `${value}%`;
		}
		return value;
	};

	const formatUnitFn = (propName, unit) => {
		if (propName === 'turnoverVolume') {
			return proxy.$i18n.locale === EN ? `${unit}` : `${unit}手`;
		}
		if (propName == 'turnoverVolumeShares') {
			return proxy.$i18n.locale === EN ? `${unit}` : `${unit}股`;
		}
		return unit;
	};

	const formatUnitStyleFn = (propName, value) => {
		if (propName == 'change' || propName == 'changePct') {
			return value > 0 ? 'up' : 'down';
		}
		return null;
	};

	return rowArray.map(item => {
		let value = props.stockQuoteData[item.prop];

		// 中文时可能会使用万手，切换至英文时需要将手置换为股 - A股 一手固定100股
		if (proxy.$i18n.locale === EN && item.prop === 'turnoverVolume') {
			value *= 100; // 将 turnoverVolume 单位由手转换为股
		}

		const { value: convertedValue, unit } = convertNumberToCNUnit(value);
           console.log("🚀 ~ unit:", unit)
           
		return {
			label: item.label,
			value: formatValueFn(item.prop, convertedValue),
			unit: formatUnitFn(item.prop, unit),
			unitStyle: formatUnitStyleFn(item.prop, convertedValue)
		};
	});
});
</script>

<style lang="less" scoped>
.stock-info-box-right {
	display: flex;
	.card-item {
		width: auto !important;
		margin-right: 40px;
		&:nth-child(4) {
			margin-right: 16px;
		}
	}

	.right-tip {
		margin: auto 0;
		background-color: var(--fill-normal-color, #f2f3f5);
		.down-icon {
			outline: none;
			cursor: pointer;
			font-size: 24px;
			transition: transform 0.3s;
			transform-origin: center;
			color: #4e5969 !important;
		}
		.animate {
			transform: rotate(-180deg);
		}
	}
}

.card-item {
	text-align: right;
	width: 82px;
	p {
		font-size: 14px;
		font-weight: 400;
		&:nth-child(1) {
			color: var(--t-emphasis-color, #1d2129);
			margin-bottom: 8px;
		}

		&:nth-child(2) {
			color: var(--t-secondary-info-color, #86909c);
		}
	}
}
</style>
